import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./login.scss";
import { IoCloseCircleOutline } from "react-icons/io5";
import { AuthContext } from "../../context/AuthContext.js";

const Rank_Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [code, setCode] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");

  const devApiLink = "http://localhost:4348/api/v1";
  const apiLink = "https://xl-api.notionspromos.com/api/v1";

  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);

  const registerUser = async (ev) => {
    ev.preventDefault();

    dispatch({ type: "LOGIN_START" });

    try {
      const credentials = {
        email,
        password,
      };

      await axios.post(`${apiLink}/register`, {
        name,
        email,
        password,
        code,
        phone,
        city,
      });
      const login = await axios.post(`${apiLink}/login`, credentials);
      dispatch({ type: "LOGIN_SUCCESS", payload: login.data });
      // navigate("/login");
      setError("");
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setError(
          "Registration failed. Please check the provided information and try again."
        );
      } else if (error.response && error.response.status === 500) {
        setError("Server error. Please try again later");
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
      dispatch({ type: "LOGIN_FAILURE", payload: error });
    }
  };

  return (
    <>
      <form className="_form" onSubmit={registerUser}>
        <label className="_label"> Code</label>
        <input
          type="text"
          placeholder="SFI-ABC123"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <label className="_label"> Full Name </label>
        <input
          type="text"
          placeholder="John Doe"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <label className="_label"> Email </label>
        <input
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label className="_label"> Phone </label>
        <input
          type="tell"
          placeholder="+966 123456789"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        <label className="_label"> City</label>
        <input
          type="text"
          placeholder="Riyadh"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />

        <label className="_label"> Password</label>
        <input
          type="password"
          placeholder="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button>Register</button>

        <small style={{ color: "red" }}>{error}</small>
      </form>
    </>
  );
};

export default Rank_Register;
